import { push, deleted, get, getAll } from "./didStore";
let zIndex = 0;
export const addDid = (options) => {
    const emits = () => {
        options
            .map((item) => {
            return item;
        })
            .forEach((items) => {
            const inString = (item) => {
                const html = document.querySelector(item);
                console.log(html);
                if (html) {
                    zIndex++;
                    items.zIndex = zIndex * 100;
                    return push(html, items);
                }
                else {
                    throw Error("找不到该元素");
                }
            };
            const inHTML = (item) => {
                zIndex++;
                items.zIndex = zIndex * 100;
                return push(item, items);
            };
            const checkType = (item) => {
                if (typeof item === "string") {
                    return inString(item);
                }
                else if (item instanceof HTMLElement) {
                    return inHTML(item);
                }
            };
            checkType(items.html);
        });
    };
    setTimeout(() => {
        emits();
    });
};
export const deleteDid = (placeCode) => {
    const inString = (item) => {
        item && deleted(item);
    };
    const checkType = (item) => {
        if (typeof item === "string") {
            inString(item);
        }
    };
    if (placeCode instanceof Array) {
        placeCode.forEach((item) => {
            checkType(item);
        });
    }
    else {
        checkType(placeCode);
    }
};
export const getDid = (placeCode) => {
    const inString = (item) => {
        return get(item);
    };
    const checkType = (item) => {
        if (typeof item === "string") {
            return inString(item);
        }
    };
    if (placeCode instanceof Array) {
        return placeCode.map((item) => {
            return checkType(item);
        });
    }
    else {
        return checkType(placeCode);
    }
};
export const getAllDid = () => {
    return getAll();
};
//# sourceMappingURL=index.js.map